import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { ShareTrackService } from '../../services/share-track-service';
import { ShareTrackApi } from '../../apis/share-track-api';
import type { ShareTrackData } from '../../types';

@injectable()
export class ShareTrackRepositoryImpl implements ShareTrackService {
    constructor(
        @inject(ShareTrackApi) private _shareTrackApi: ShareTrackApi
    ) {
    }

    trackShare(data: ShareTrackData) {
        return this._shareTrackApi.trackShare(data);
    }
}
